import React, { ReactNode, useEffect, useMemo } from 'react';

import { Tag } from 'antd';
import Footer from '../components/Footer';
import ProLayout from '@ant-design/pro-layout';
import { UserOutlined } from '@ant-design/icons';
import RightContent from '../components/RightContent';
import { NotificationBell } from '../components/Notifications';

// Navigation
import { Link, useLocation } from 'react-router-dom';

// Utils
import getMenuItems from './getMenuItems';
import { useAppSelector } from '../../../store/store';
import { useWindowSize } from '../../../utils/useWindowSize';
import { isActionableForUser } from '../../../utils/validateRole';

// Constants
import { LOCAL_MODE } from '../../../config';
import { PAGE_TITLE } from '../../../constants/page';
import logo from '../../../assets/images/logo_short.png';
import { PRIMARY_COLOR } from '../../../constants/colors';
import { PERMISSIONS } from '../../../constants/permissions';

// Interfaces
import type { IUser } from '../../../interfaces/user';

interface LayoutProps {
  children: ReactNode;
  isWhiteLayout?: boolean;
}

const contentStyle = { margin: 0, padding: 0 } as const;

export const Layout: React.FC<LayoutProps> = (props) => {
  const { width } = useWindowSize();

  const location = useLocation();
  const isMobile = width && width <= 767;

  const user = useAppSelector((state) => state.auth.user) as IUser;

  const routes = getMenuItems(isMobile as boolean, user);

  useEffect(() => {
    setTimeout(() => {
      if (LOCAL_MODE) {
        document.title = PAGE_TITLE + ' | Modo offline';
      } else {
        document.title = PAGE_TITLE;
      }
    }, 1);
  }, []);

  const actions = useMemo(() => {
    if (LOCAL_MODE) return null;
    return isActionableForUser(user, [PERMISSIONS.COMUNICACIONES_EMAILS_SELF_LIST])
      ? [<NotificationBell key="notification" />]
      : null;
  }, [user]);

  return (
    <ProLayout
      layout="mix"
      logo={
        <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
          <Link to="/">
            <img style={{ height: 18 }} src={logo}></img>
          </Link>
          {LOCAL_MODE ? (
            <div style={{ marginLeft: 10, marginBottom: 2 }} key="local">
              <Tag color={PRIMARY_COLOR}>Modo offline</Tag>
            </div>
          ) : null}
        </div>
      }
      fixSiderbar
      // @ts-ignore
      title={' '}
      route={routes}
      location={location}
      contentStyle={contentStyle}
      style={{ height: '100vh' }}
      actionsRender={() => actions}
      footerRender={() => <Footer />}
      collapsed={!isMobile ? true : undefined}
      className={props.isWhiteLayout ? 'white-layout' : ''}
      collapsedButtonRender={!isMobile ? () => null : undefined}
      avatarProps={{
        size: 'small',
        icon: <UserOutlined />,
        style: { backgroundColor: PRIMARY_COLOR },
        title: isMobile ? undefined : `${user.nombre} ${user.apellido}`,
        render: (props, dom) => {
          return <RightContent dom={dom} />;
        }
      }}
      menuItemRender={(item, dom) => {
        return <Link to={item.path as string}>{dom}</Link>;
      }}
      token={{
        sider: {
          colorMenuBackground: 'white'
        }
      }}
    >
      {props.children}
    </ProLayout>
  );
};

export default Layout;
